import React, { useEffect, useState } from 'react';
import * as Form from '@radix-ui/react-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../redux/rootReducer';
import { loginRequest } from '../../redux/auth/action';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useRole from '../../hook/useRole';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';

interface LoginFormData {
  username: string;
  password: string;
}

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authState = useSelector((state: RootState) => state.auth);
  const role = useRole();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const username = formData.get('username');
    const password = formData.get('password');
    const payload: LoginFormData = {
      username: username?.toString() ?? '',
      password: password?.toString() ?? '',
    };

    dispatch(loginRequest(payload));
  };

  useEffect(() => {
    // Khi authState.isAuthenticated thành true và role đã được lấy (có thể thay đổi nếu token thay đổi)
    if (authState.isAuthenticated) {
      if (role === 'ROLE_EMPLOYEE') {
        navigate('/customer');
      } else {
        navigate('/');
      }
    }
  }, [authState, role, navigate]);

  return (
    <>
      <Form.Root onSubmit={handleSubmit} className="w-[300px] space-y-4">
        <Form.Field name="username">
          <div className="flex flex-col gap-2">
            <Form.Label className="text-sm font-medium text-gray-700">
              Tên đăng nhập
            </Form.Label>
            <Form.Control asChild>
              <input
                type="text"
                required
                className="rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Nhập tên đăng nhập"
              />
            </Form.Control>
            <Form.Message match="valueMissing" className="text-sm text-red-500">
              Vui lòng nhập tên đăng nhập
            </Form.Message>
          </div>
        </Form.Field>

        <Form.Field name="password">
          <div className="flex flex-col gap-2">
            <Form.Label className="text-sm font-medium text-gray-700">
              Mật khẩu
            </Form.Label>
            <div className="relative">
              <Form.Control asChild>
                <input
                  type={showPassword ? 'text' : 'password'}
                  required
                  className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập mật khẩu"
                />
              </Form.Control>
              <div
                className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <EyeInvisibleOutlined className="text-gray-500 hover:text-gray-700" />
                ) : (
                  <EyeOutlined className="text-gray-500 hover:text-gray-700" />
                )}
              </div>
            </div>
            <Form.Message match="valueMissing" className="text-sm text-red-500">
              Vui lòng nhập mật khẩu
            </Form.Message>
          </div>
        </Form.Field>

        <Form.Submit asChild>
          <button className="w-full rounded-md bg-blue-600 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
            Đăng nhập
          </button>
        </Form.Submit>
      </Form.Root>
      <ToastContainer />
    </>
  );
};

export default LoginForm;
